<template>
    <v-container fluid class="user-list">
      <v-row class="ma-0">
        <v-card width="100%" class="ma-1">
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="12" md="3" class="d-flex justify-space-between justify-md-start">

              </v-col>
              <v-col cols="12" md="3" class="mt-3">
                <div :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : 'width: 250px'">
                  <v-text-field
                      dense
                      :full-width=$vuetify.breakpoint.smAndDown
                      outlined
                      hide-details
                      @keyup="filtersCompanies"
                      v-model="searchCompany"
                      :label="languageData.search"
                      prepend-inner-icon="mdi-magnify"
                  ></v-text-field>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-row>
      <v-row class="ma-0">
        <v-card width="100%" class="ma-1">
          <v-card-text>
            <v-row class="ma-0">
              <v-card width="100%" class="ma-1">
                <v-card-text>
                  <v-data-table
                      loading-text="Loading... Please wait"
                      class="users-table"
                      :headers="headers"
                      :options.sync="pagination"
                      :server-items-length="totalItems"
                      :items-per-page-options="rowsPerPageItems"
                      :footer-props="footerOptions"
                      :page.sync="currentPage"
                      :loading="loadingCompanies"
                      :items="dataReceive">
                    <template v-slot:item.logo="{ item }">
                      <v-avatar :color="item.hexColor" size="40" class="mr-2">
                        <span class="white--text headline">{{ getFirstLetter(item.company_name) }}</span>
                      </v-avatar>
                    </template>
                    <template v-slot:item.name="{ item }">
                      {{ item.company_name }}
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <td class="justify-center">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                @click="editCompany(item.id)"
                                icon>
                              <v-icon color="teal">edit</v-icon>
                            </v-btn>
                          </template>
                          <span>Edit</span>
                        </v-tooltip>
                      </td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-row>
          </v-card-text>
        </v-card>
      </v-row>
      <ModalInfo  :typeInfo="modalSaveInfoData.typeInfo" :headModal="modalSaveInfoData.head" :btnAgreeText="languageData.btnAgreeText" @clicked="hideModalSaveInfo" :show-modal="isShowSaveModalInfo" :text-modal="modalSaveInfoData.textInfo"></ModalInfo>
    </v-container>
</template>

<script type="text/javascript">
  import { mapState, mapActions } from "vuex";
  import router from "../../../../../router";
  import ModalInfo from "../../../../components/ModalInfo/ModalInfo";
  import eventBus from "../../../../event-bus/eventBus";

  export default {
    name: "ListCompany",
    data() {
      return {
        footerOptions: {
          'items-per-page-options': [20, 50, 100],
          'disablePagination': false
        },
        currentPage: 1,
        searchCompany: "",
        isShowSaveModalInfo: false,
        modalSaveInfoData: {},
        searchTask: null,
        searchDebouceTime: 500
      }
    },
    components: {
      ModalInfo
    },
    computed: {
      ...mapState("getCompanies", {
        dataReceive: state => state.dataReceive,
        totalItems: state => state.pagination.totalItems,
        rowsPerPageItems: state => state.pagination.rowsPerPage,
        headers: state => state.headers,
        sortBy: state => state.pagination.sortBy,
        loadingCompanies: state => state.loadingCompanies
      }),
      pagination: {
        get:function() {
          return this.$store.state.getCompanies.pagination;
        },
        set:function(value){
          this.searchCompanies(value);
        }
      }
    },
    mounted() {
      const language = this.getCurrentLanguage;
      this.getHeadersTable({creds: {language}});
      eventBus.$on("setDisablePagination", (value) => {
        this.footerOptions["disablePagination"] = value;
      });
      eventBus.$on("changeLanguage", (value) => {
        const language = value;
        this.getHeadersTable({creds: {language}});
      });
      if(localStorage.getItem("textSaveCompany")) {
        this.modalSaveInfoData.typeInfo = "success";
        this.modalSaveInfoData.textInfo = localStorage.getItem("textSaveCompany");
        this.modalSaveInfoData.head = localStorage.getItem("messageSaveCompany");
        this.isShowSaveModalInfo = true;
        localStorage.removeItem("textSaveCompany");
        localStorage.removeItem("messageSaveCompany");
      }
    },
    methods: {
      ...mapActions("getCompanies", ["getHeadersTable", "getCompanies"]),
      hideModalSaveInfo: function() {
        this.isShowSaveModalInfo = false;
      },
      searchCompanies: function (valueSearch={}, filters=false) {
        valueSearch.language = this.getCurrentLanguage;
        valueSearch.search = null;
        valueSearch.filters = filters;
        valueSearch.search = this.searchCompany;
        this.getCompanies({ valueSearch });
        if(filters) {
          this.currentPage = 1;
        }
      },
      getFirstLetter(companyName) {
        return companyName.charAt(0);
      },
      filtersCompanies: function() {
          clearTimeout(this.searchTask);
          this.searchTask = setTimeout(() => {this.searchCompanies({}, true)}, this.searchDebouceTime);
      },
      editCompany: function(id) {
        router.push({ path: "/companies/edit", query: { companyId: id } })
      }
    }
  }
</script>